const ABOUT = {
    title: 'About Me',
    description: 'I am a passionate developer with a knack for creating efficient and scalable web applications. With skills in both front-end and back-end technologies, I strive to deliver seamless user experiences.',
    skills: [
        {
            id: 1,
            title: 'HTML & CSS',
            level: 'mid-level',
            experience: '5 years (2 commercial) experience.',
            icon: ''
        },
        {
            id: 2,
            title: 'PHP',
            level: 'mid-level',
            experience: '5 years (2 commercial) experience.',
            icon: ''
        },
        {
            id: 3,
            title: 'MySQL',
            level: 'mid-level',
            experience: '5 years (2 commercial) experience.',
            icon: ''
        },
        {
            id: 4,
            title: 'JavaScript',
            level: 'mid-level',
            experience: '3 years (2 commercial) experience.',
            icon: ''
        },
        {
            id: 5,
            title: 'Vue.js',
            level: 'Junior',
            experience: 'less than 1 year experience.',
            icon: ''
        },
        {
            id: 6,
            title: 'Laravel',
            level: 'Junior',
            experience: 'less than 1 year experience.',
            icon: ''
        },
        {
            id: 7,
            caption: 'My skillset is always evolving as I embrace new technologies and methodologies to stay at the forefront of the industry. Currently i am learning React, Next, and Typescript to expand my capabilities in full-stack development.',
        }
    ],
    qualifications: [
        {
            cert: 'Azure cloud fundamentals',
            institution: 'Microsoft Learn',
            year: '2022'
        },
        {
            cert: 'Bachelor of Science in Computing and IT (Software Development)',
            institution: 'Open University',
            year: '2024'
        },
        {
            cert: 'Continuous learning through tutorials and courses on web development, cloud computing, and software engineering.',
            institution: 'Udemy',
            year: 'Continous'
        },
    ],
    experience: [
        {
            role: 'Web Developer',
            company: 'Naked Kitchens',
            duration: 'Sep 2023 - Present',
            details: 'My duties include maintaining and enhancing the company website, developing internal tools to streamline operations, and integrating third-party services to improve overall functionality. I have successfully implemented several features that have improved user experience, search engine optimisation, and operational efficiency.'
        },
        {
            role: 'Freelance Web Developer',
            company: 'Home',
            duration: 'Jan 2020 - Present',
            details: 'Built and managed websites for people i know using HTML, CSS, and JavaScript for front end design and functionality. I also use PHP and MySQL for back-end development and database management. I have successfully delivered projects that have enhanced client online presence and improved user engagement.'
        }
    ]
};

export default ABOUT;